"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const intl_1 = require("@kyruus/intl");
const MobileTeleHealth_1 = __importDefault(require("@kyruus/react-ikons/MobileTeleHealth"));
const Phone_1 = __importDefault(require("@kyruus/react-ikons/Phone"));
const messages_1 = __importDefault(require("../../lib/messages"));
const VisitTypes_1 = require("../../lib/constants/VisitTypes");
const VisitLabel = ({ Wrapper, IconWrapper, iconSize, LabelWrapper, Label, type }) => {
    let message = {};
    let Icon;
    switch (type) {
        case VisitTypes_1.PHONE:
            Icon = react_1.default.createElement(Phone_1.default, { size: iconSize });
            message = messages_1.default.appointmentPhoneTitle;
            break;
        case VisitTypes_1.VIDEO:
            Icon = react_1.default.createElement(MobileTeleHealth_1.default, { size: iconSize });
            message = messages_1.default.appointmentVideoTitle;
            break;
        default:
            message = messages_1.default.appointmentInPersonTitle;
    }
    return (react_1.default.createElement(Wrapper, { "data-testid": "VisitTypeLabel" },
        react_1.default.createElement(IconWrapper, null, Icon),
        react_1.default.createElement(LabelWrapper, null,
            react_1.default.createElement(Label, null,
                react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, message))))));
};
VisitLabel.defaultProps = {
    Wrapper: react_1.Fragment,
    IconWrapper: react_1.Fragment,
    LabelWrapper: react_1.Fragment,
    Label: react_1.Fragment,
    iconSize: '18px',
    type: VisitTypes_1.IN_PERSON
};
exports.default = VisitLabel;
//# sourceMappingURL=VisitLabel.js.map